import { CostCentreDetails } from 'core/centrocosto/components/CostCentreDetails/CostCentreDetails';
import { CostCentreTotalsContext } from 'core/centrocosto/contexts/CostCentreTotalsContext';
import { useContext } from 'react';
import { LinkButton } from 'shared/components';
import { formatDateParams } from 'shared/utils';
import { CostCentreTotals } from 'core/centrocosto/components/CostCentreTotals/CostCentreTotals';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { PageTitle } from 'shared/components/Fonts';

export function CostCentreTotalsPage() {
  const { costCentreTotals, goBack, goToMovementsByCC, searchParams } = useContext(
    CostCentreTotalsContext,
  );
  return (
    <Container>
      {costCentreTotals ? (
        <>
          <Row className="mb-3">
            <Col>
              <CostCentreDetails
                costCentreData={costCentreTotals}
                goToMovementsAction={goToMovementsByCC}
                goBackAction={goBack}
                periodo={formatDateParams(searchParams)}
              />
            </Col>
          </Row>
          <Col>
            <PageTitle>Totales por Centro de Costos</PageTitle>
            <CostCentreTotals />
          </Col>
          <Row>
            <Row>
              {!costCentreTotals.esCentroCostoRaiz || (
                <Col className="text-center">
                  <LinkButton onClick={goToMovementsByCC}>
                    Ver movimientos del centro de costo
                  </LinkButton>
                </Col>
              )}
              <Col className="text-center">
                <LinkButton onClick={goBack}>Volver</LinkButton>
              </Col>
            </Row>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col>
              <Alert className="text-center">
                No hay movimientos en el período para el centro de costo seleccionado
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <LinkButton onClick={goBack}>Volver</LinkButton>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}
